export default class DynamicTitle extends HTMLDivElement {

    constructor() {
        super();
    }

    connectedCallback() {
        const dynamicTitle = this.querySelector('#dynamic-title');
        const divObservedClass = dynamicTitle.dataset.divObserved;
        const divObserved = this.querySelector('.'+divObservedClass);

        function onWidgetAppear(reviewsExist) {
            if (reviewsExist) {
                dynamicTitle.classList.remove('d-none');
            } else {
                dynamicTitle.classList.add('d-none');
            }
        }

        // On vérifie si la qui contient les avis est présente
        const observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
                for (const node of mutation.addedNodes) {
                    if (node.nodeType !== 1) continue; // uniquement éléments HTML
                    const found = node.querySelector?.('div');
                    if (found) {
                        onWidgetAppear(true);
                        return;
                    }
                }
            }
        });

        if (divObserved) {
            observer.observe(divObserved, {
                childList: true,
                subtree: true
            });
        }
    }
}
